import { Grid, TextField } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectedUnitBestBets } from '@AMIEWEB/NewOrder/Store/Order.selectors';

const useStyles = makeStyles()(theme => ({
    wrapper: {
        display: 'grid',
        gap: '12px',
    },
    disabled: {
        cursor: 'not-allowed',
    },
    fieldStyle: {
        '& .MuiFilledInput-root': {
            backgroundColor: `${theme.palette.system.grayChip} !important`,
        },
        '&:hover .MuiFilledInput-root': {
            backgroundColor: `${theme.palette.system.silver} !important`,
        },
        '&:hover .MuiInputLabel-root': {
            color: `${theme.palette.system.primary} !important`,
        },
        '& .Mui-disabled .MuiFilledInput-input': {
            visibility: 'hidden',
        },
        '& .MuiFilledInput-input': {
            paddingTop: '20px',
        },
        '& .MuiFormLabel-filled': {
            font: '12px Roboto',
        },
    },
}));

export const BestBets = () => {
    const bestBets = useSelector(selectedUnitBestBets);

    const { t } = useTranslation();
    const { classes } = useStyles();
    return (
        <Grid container>
            <Grid item xs={6} className={classes.wrapper}>
                <TextField
                    variant="filled"
                    fullWidth
                    id={'bestBets'}
                    name={'bestBets'}
                    InputProps={{
                        readOnly: true,
                    }}
                    className={`${classes.disabled} ${classes.fieldStyle}`}
                    defaultValue={bestBets}
                    value={bestBets}
                    label={t('order.newOrderCreation.tabs.bestBets')}
                    type={'string'}
                />
            </Grid>
        </Grid>
    );
};